// ======================================================================
// File Name       : ContentQuestionDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import ContentQuestionDetail from '../../components/content/ContentQuestionDetail';
import DialogConfirm from '../../components/DialogConfirm';
import * as ContentQuestionAction from '../../actions/content/ContentQuestionAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { CONTENT_QUESTION, CONTENT_QUESTION_LIST } from '../../constants/PathConstants';
import { DATA_AFFIILIATION_TYPE, CONTENT_QUESTION_KIND } from '../../constants/ContentConstant';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { CONTENT_QUESTION_EDIT } from '../../constants/FunctionConstants';
import { htmlEntities } from '../../utils/index';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';
import { checkPreviewDetailQuestionPath } from '../../utils/ContentQuestionUtils';

class ContentQuestionDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      questionInfo: {
        questionKind: 0,
        questionSecernId: null,
        questionTitle: null,
        questionContent: null,
        questionUseForm: 0,
        answerFormula: 0,
        optionMarkKind: 0,
        inputLimitType: 0,
        inputLimit: 0,
        optionRandomUse: 0,
        correctAnswer: null,
        correctNumber: 0,
        optionArray: [],
        subQuestionArray: [],
        questionViewDirection: 0,
        absolutePoint: 0,
        limitTime: 0,
        sankakuUseDistinct: 0,
        dataAffiliationType: null,
        convertStatus: null,
        convertErrorMessage: null,
        explanationContent: null,
        hintContent: null,
      },
      redirectToList: false,
    };
    this.handleBackBtnClick = this.handleBackBtnClick.bind(this);
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind(this);
    this.onDeleteDialogOk = this.onDeleteDialogOk.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.getQuestionDetail(match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    const { questionInfo } = nextProps;
    this.setState({
      questionInfo,
    });
  }

  getQuestionDetail(questionId) {
    if (questionId) {
      this.props.dispatch(ContentQuestionAction.getQuestionDetail(questionId));
    }
  }

  handleBackBtnClick() {
    this.props.history.push(CONTENT_QUESTION_LIST);
  }

  openDeleteDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showDeleteModal: true });
  }

  onDeleteDialogCancel() {
    this.setState({ showDeleteModal: false });
  }

  onDeleteDialogOk() {
    this.setState({ showDeleteModal: false });
    const { questionSecernId } = this.state.questionInfo;  
    const { history } = this.props; 
    this.props.dispatch(ContentQuestionAction.deleteQuestionDetail(questionSecernId)).then(() => {
      // Back to question top
      history.push(CONTENT_QUESTION_LIST);
    });
  }

  render() {
    const { questionInfo } = this.state;
    const {
      questionKind,
      questionSecernId,
      questionTitle,
      questionContent,
      questionUseForm,
      answerFormula,
      optionMarkKind,
      inputLimitType,
      inputLimit,
      optionRandomUse,
      correctAnswer,
      correctNumber,
      optionArray,
      subQuestionArray,
      questionViewDirection,
      absolutePoint,
      limitTime,
      sankakuUseDistinct,
      dataAffiliationType,
      convertStatus,
      convertErrorMessage,
      questionZipFileName,
      explanationUse,
      explanationHtmlUse,
      explanationContent,
      explanationZipFileName,
      hintUse,
      hintHtmlUse,
      hintContent,
      hintZipFileName,
      questionAttributeList,
    } = questionInfo;
    const questionContentTemp = questionContent ? htmlEntities(questionContent) : '';
    const correctConvertedAnswer = correctAnswer ? htmlEntities(correctAnswer) : '';
    const link = `${questionSecernId}/edit`;
    const canAccess = canAccessRoute(CONTENT_QUESTION_EDIT);
    const isPreview = checkPreviewDetailQuestionPath(Path.CONTENT_QUESTION_DETAIL_PREVIEW);
    return (
      <div>
        {!isPreview && (
          <CustomLink
            className="margin-right-7 url-list"
            to={Path.CONTENT_QUESTION_LIST}
            text="問題一覧に戻る"
            icon="bi bi-chevron-left"
          />
        )}
        <Header name="問題の詳細" />
        <ContentQuestionDetail
          questionKind={questionKind}
          questionSecernId={questionSecernId}
          questionTitle={questionTitle}
          questionContent={questionContentTemp}
          questionUseForm={questionUseForm}
          answerFormula={answerFormula}
          optionMarkKind={optionMarkKind}
          inputLimitType={inputLimitType}
          inputLimit={inputLimit}
          optionRandomUse={optionRandomUse}
          correctAnswer={correctConvertedAnswer}
          correctNumber={correctNumber}
          optionArray={optionArray}
          subQuestionArray={subQuestionArray}
          questionViewDirection={questionViewDirection}
          absolutePoint={absolutePoint}
          limitTime={limitTime}
          sankakuUseDistinct={sankakuUseDistinct}
          link={link}
          onBackBtnClick={this.handleBackBtnClick}
          onDeleteBtnClick={this.openDeleteDialog.bind(this, MessageTemplate.MSG_DEL_QUESTION, null)}
          dataAffiliationType={dataAffiliationType}
          convertStatus={convertStatus}
          convertErrorMessage={convertErrorMessage}
          canAccess={canAccess}
          questionZipFileName={questionZipFileName}
          explanationUse={explanationUse}
          explanationHtmlUse={explanationHtmlUse}
          explanationContent={explanationContent}
          explanationZipFileName={explanationZipFileName}
          hintUse={hintUse}
          hintHtmlUse={hintHtmlUse}
          hintContent={hintContent}
          hintZipFileName={hintZipFileName}
          questionAttributeList={questionAttributeList}
        />
        <DialogConfirm
          showModal={this.state.showDeleteModal}
          onCancel={this.onDeleteDialogCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionInfo } = state.question;
  return { ...{ questionInfo } };
};

export default connect(mapStateToProps)(ContentQuestionDetailContainer);
